/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

function handleInitialAdjustments({
  questionnaire,
  setQuestionnaire,
  setFieldValue,
  personData,
}) {
  try {
    questionnaire = questionnaire.map(question => {
      
      if(question.behaviorObject.sectionName === 'PERSON') {
        question.visibleQuestion = [1885,1886,1887].includes(question.idQuestion);
      }

      if (question.idQuestion === 1885) {
        question.answer = personData?.legalPersonId;
        if (!question.answer) question.behaviorObject.isRequired = false;
        setFieldValue && setFieldValue(question.key, personData?.legalPersonId)
      }

      if (question.idQuestion === 1886) {
        question.answer = personData?.firstName;
        setFieldValue && setFieldValue(question.key, personData?.firstName)
      }

      if (question.idQuestion === 1887) {
        question.answer = personData?.lastName;
        setFieldValue && setFieldValue(question.key, personData?.lastName)
      }

      return question;
    });

    setQuestionnaire(questionnaire);

    return questionnaire;
  } catch (e) {
    console.log("PERSON - handleInitialAdjustments error", e)
  }
}

const events = {
  handleInitialAdjustments
}

export { events };